import { DashboardSummaryActionTitle, DashboardSummary, DashboardSummaryCount, DashboardSummaryHeader } from '@/components/custom/dashboard';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export default function TipsSidebar(props) {
  const { lampIcon, learningTip, requirementsTip, relatedMaterialsTip, imageAreaTip, darkeningImageTip, currentCourse } = props;
  const { t } = useTranslation();
  const { step } = useParams();

  return (
    <>
      {step === 'nome' && (
        <aside className={`page__aside animate-fade-in ${currentCourse && 'page__aside--bg'}`}>
          {currentCourse && (
            <>
              <h3
                className="page__aside-title"
                dangerouslySetInnerHTML={{ __html: t('exams.titleAsideBarSimulations', { currentCourseTitle: currentCourse?.title }) }}
              />

              <p
                className="page__aside-text"
                dangerouslySetInnerHTML={{ __html: t('lms.asideTextDescription', { currentCourseTitle: currentCourse?.title }) }}
              />

              <DashboardSummary className="mb-4">
                <DashboardSummaryHeader>
                  <DashboardSummaryCount>{currentCourse?.['student-count']}</DashboardSummaryCount>
                </DashboardSummaryHeader>
                <DashboardSummaryActionTitle dangerouslySetInnerHTML={{ __html: t('lms.studentsCourse', { currentCourseTitle: '' }) }} />
              </DashboardSummary>
            </>
          )}
        </aside>
      )}

      {step === 'objetivos' && (
        <aside className="page__aside page__aside--bg animate-fade-in">
          <img
            src={lampIcon}
            alt="ícone lâmpada"
            className="page__aside-icon"
          />

          <h3 className="page__aside-title">{t('lms.asideTitleLearning')}</h3>

          <p className="page__aside-text">
            <div dangerouslySetInnerHTML={{ __html: t('lms.asideTextLearning') }}></div>
          </p>

          <img
            src={learningTip}
            alt="dica de preenchimento"
          />
        </aside>
      )}

      {step === 'requisitos' && (
        <aside className="page__aside page__aside--bg animate-fade-in">
          <img
            src={lampIcon}
            alt="ícone lâmpada"
            className="page__aside-icon"
          />

          <h3 className="page__aside-title">{t('lms.requirements')}</h3>
          <p className="page__aside-text">
            <div dangerouslySetInnerHTML={{ __html: t('lms.asideRequirementsDescription') }}></div>
          </p>
          <p className="page__aside-text">
            <img
              src={requirementsTip}
              alt="dica de requisitos"
              style={{ width: '140px' }}
            />
          </p>

          <h3 className="page__aside-title">{t('tasks.mattersRelated')}</h3>
          <p className="page__aside-text">
            <div dangerouslySetInnerHTML={{ __html: t('lms.relatedSubjectDescription') }}></div>
          </p>
          <img
            src={relatedMaterialsTip}
            alt="dica de matérias relacionadas"
            style={{ width: '198px' }}
          />
        </aside>
      )}

      {step === 'imagem' && (
        <aside className="page__aside page__aside--bg animate-fade-in">
          <img
            src={lampIcon}
            alt="ícone lâmpada"
            className="page__aside-icon"
          />

          <h3 className="page__aside-title">{t('courses.coverImage')}</h3>
          <p className="page__aside-text">{t('courses.asideTextDescription')}</p>
          <p className="page__aside-text mb-0">
            <strong>{t('courses.observations')}</strong>
          </p>
          <ul className="page__aside-list">
            <li>
              <div dangerouslySetInnerHTML={{ __html: t('courses.asideTextDimensions') }}></div>
              <img
                src={imageAreaTip}
                alt={t('courses.asideImageSecurity')}
              />
            </li>
            <li>
              <div dangerouslySetInnerHTML={{ __html: t('courses.asideTextLegibility') }}></div>
              <br />
              <img
                src={darkeningImageTip}
                alt={t('courses.asideTextAltTip')}
              />
            </li>
          </ul>
          <p className="page__aside-text page__aside-text--tip">
            <div dangerouslySetInnerHTML={{ __html: t('courses.AsideTextTip') }}></div>
          </p>
        </aside>
      )}
    </>
  );
}
